<template>
  <div class="col-sm-6" style="padding-right: 0;">
    <multiselect
      class="filter-multiselect"
      v-model="filter.value"
      :options="options"
      :showLabels="false"
      placeholder
      v-on:input="emitToggleEvent()"
    ></multiselect>
  </div>
</template>

<script>
export default {
  name: 'DropDownFilter',
  props: ['filter'],
  data: function() {
    return {
      options: []
    };
  },
  beforeMount() {
    let promise = this.$axios.get(
      this.filter.page + '/filterDropdown?filterType=' + this.filter.id
    );

    return promise
      .then(data => {
        var items = [''];
        this.options = items.concat(data.data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    emitToggleEvent() {
      this.$emit('toggle-value');
    }
  }
};
</script>

<style>
.multiselect {
  min-height: 28px !important;
}

.multiselect__content-wrapper {
  min-width: 100%;
  min-width: -moz-available;          /* WebKit-based browsers will ignore this. */
  min-width: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
  min-width: stretch;
  width: auto;
  border-top: 1px solid #e8e8e8;
}
</style>
